const noHTMLRegex = /<[^>]*>/

export const noHTMLTest = (value) => {
  if (typeof value !== "string") return true
  return !noHTMLRegex.test(value)
}

export default noHTMLTest
